var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-reigster-consumer-error"},[_vm._v("\n\treigster-error\n")])}
var staticRenderFns = []

export { render, staticRenderFns }